// MultiStepForm.js
import React, { useEffect, useState } from "react";
import { useRef } from "react";
import {
  Container,
  Form,
  Button,
  ProgressBar,
  Nav,
  Alert,
} from "react-bootstrap";
import SignaturePad from "react-signature-canvas"; // Import the SignaturePad component
import "./Signature.css";
import { connect } from "react-redux";
import { getSasToken } from "../../store/thunk/user";
import { updateForm } from "../../utils/updateForm";
import { dataURLtoBlob } from "../../utils/dataURLtoBlob";
import { toast } from "react-toastify";
import { triggerButtonClick } from "../../utils/triggerLibraryButton";
import { uploadDocumentAndGetUrl } from "../../utils/uploadDocument";
import BankDetailsDownload from "./Download/BankDetailsDownload";
import { Tabs, Tab, Box } from "@mui/material";

const BankDetails = ({
  currentDocument,
  documentList,
  user,
  sasToken,
  ipAddress,
  getSasToken,
}) => {
  const [step, setStep] = useState(1);
  const [progress, setProgress] = useState(0); // Progress percentage for each step
  const [value, setValue] = useState(0);
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };
  const [formData, setFormData] = useState({
    nameOnBank: "",
    bankName: "",
    accountNumber: "",
    sortCode: "",
    bankDetailConsent: false,
    consent: false,
    signature: "", // Store the signature data as a string
  });
  const [errors, setErrors] = useState({});
  const sigPadRef = useRef(null); // Reference to the SignaturePad component
  useEffect(() => {
    setFormData(currentDocument);
    if (currentDocument?.step) {
      setStep(currentDocument?.step);
    }
    if (currentDocument?.progress) {
      setProgress(currentDocument?.progress);
    }
    if (currentDocument?.progress === 100) {
      getSasToken();
    }
  }, []);
  // Function to handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
    setErrors({ ...errors, [name]: "" });
  };

  // Function to validate each step
  const validateStep = () => {
    let formErrors = {};
    if (step === 1) {
      if (!formData.nameOnBank) formErrors.nameOnBank = "Name field is required";
      if (!formData.bankName)
        formErrors.bankName = "Bank Name field is required";
      if (!formData.accountNumber)
        formErrors.accountNumber = "Account number field is required";
      if (!formData.sortCode)
        formErrors.sortCode = "Sort code field is required";
      if (!formData.bankDetailConsent)
        formErrors.bankDetailConsent = "This is a required field";
    } else if (step === 2) {
      if (!formData.consent) formErrors.consent = "You must agree to the terms";
      if (sigPadRef.current.isEmpty())
        formErrors.signature = "Signature is required"; // Check if the signature pad is empty
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  // Function to go to the next step
  const nextStep = () => {
    if (validateStep()) {
      const payload = {
        [currentDocument["key"]]: {
          name: currentDocument?.name,
          ...formData,
          progress: progress + 50,
          step: step + 1,
        },
      };
      updateForm(payload, documentList, user);
      setStep(step + 1);
      setProgress(progress + 50);
    }
  };

  // Function to go to the previous step
  const prevStep = () => {
    setStep(step - 1);
    setProgress(progress - 50);
  };

  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateStep()) {
      // Get the signature data as a base64 image
      const signatureImage = sigPadRef.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
      const signatureBlob = dataURLtoBlob(signatureImage);
      setFormData({ ...formData, signature: signatureImage });
      // Create a FormData object
      const formDataSign = new FormData();
      // Append the Blob as a file to the FormData
      // The second argument is the file name, which you can customize as needed
      formDataSign.append(
        "file",
        signatureBlob,
        `${[currentDocument["key"]]}.png`
      );
      // Send the FormData using postMultiPartFormData
      const documentUrl =
        (await uploadDocumentAndGetUrl(formDataSign, user?.token)) || "";
      if (documentUrl) {
        const payload = {
          [currentDocument["key"]]: {
            name: currentDocument?.name,
            ...formData,
            progress: 100,
            step: step,
            signature: documentUrl,
            signDate: new Date(),
            ipAddress: ipAddress,
          },
        };
        updateForm(payload, documentList, user);
        toast.success("Successfully filled the form.");
        triggerButtonClick();
      } else {
        toast.error(
          "Something went wrong while upload signature. please try again."
        );
      }
      // Additional submit logic here, such as sending formData to the server
    }
  };
  // Clear the signature pad
  const clearSignature = () => {
    sigPadRef.current.clear();
    setFormData({ ...formData, signature: "" });
  };
  return (
    <Container className="mt-5">
      {currentDocument?.progress === 100 ? (
        <>
          <BankDetailsDownload
            data={currentDocument}
            sasToken={sasToken}
            user={documentList?.userDetail}
          />
          <Box sx={{ width: "100%" }}>
            <Tabs
              value={value}
              onChange={handleTabChange}
              aria-label="basic tabs example"
              className="tab mt-2"
            >
              <Tab label="Bank Details" />
            </Tabs>
            {value === 0 && (
              <div className="container">
                <div className="row">
                  <h2>Bank Details</h2>
                  <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between"><strong>Your name (as it appears on your account)</strong> <span>{currentDocument?.nameOnBank || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between"><strong>Bank/Building Society Name</strong> <span>{currentDocument?.bankName || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between"><strong>Account Number</strong> <span>{currentDocument?.accountNumber || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between"><strong>Sort Code</strong> <span>{currentDocument?.sortCode || '--'}</span></li>
                    <li class="list-group-item d-flex justify-content-between"><strong>- I confirm that these bank details are correct to which I require payment. I accept that any errors in these details may result in my payment being delayed. I accept that it is my responsibility to advise you of any changes in these details.</strong></li>
                  </ul>
                </div>
              </div>
            )}
          </Box>
        </>
      ) : (
        <>
          <Nav variant="pills" className="justify-content-center mb-3">
            <Nav.Item>
              <Nav.Link
                className={step === 1 ? "text-light" : ""}
                active={step === 1}
              >
                Step 1
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className={step === 2 ? "text-light" : ""}
                active={step === 2}
              >
                Step 2
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <ProgressBar now={progress} className="mb-4" />

          <Form onSubmit={handleSubmit}>
            {step === 1 && (
              <div>
                <h3>Section 1: Bank Details</h3>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Your name (as it appears on your account)
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="nameOnBank"
                    value={formData.nameOnBank}
                    onChange={handleChange}
                    isInvalid={!!errors.nameOnBank}
                    required
                  />
                  {errors.nameOnBank && <Alert variant="danger">{errors.nameOnBank}</Alert>}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Bank/Building Society Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="bankName"
                    value={formData.bankName}
                    onChange={handleChange}
                    isInvalid={!!errors.bankName}
                    required
                  />
                  {errors.bankName && (
                    <Alert variant="danger">{errors.bankName}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Account Number</Form.Label>
                  <Form.Control
                    type="text"
                    name="accountNumber"
                    value={formData.accountNumber}
                    onChange={handleChange}
                    isInvalid={!!errors.accountNumber}
                    required
                  />
                  {errors.accountNumber && (
                    <Alert variant="danger">{errors.accountNumber}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Sort Code</Form.Label>
                  <Form.Control
                    type="text"
                    name="sortCode"
                    value={formData.sortCode}
                    onChange={handleChange}
                    isInvalid={!!errors.sortCode}
                    required
                  />
                  {errors.sortCode && (
                    <Alert variant="danger">{errors.sortCode}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    name="bankDetailConsent"
                    label="I confirm that these bank details are correct to which I require payment. I accept that any errors in these details may result in my payment being delayed. I accept that it is my responsibility to advise you of any changes in these details."
                    checked={formData.bankDetailConsent} // Use checked for checkboxes
                    onChange={handleChange}
                    isInvalid={!!errors.bankDetailConsent}
                  />
                  {errors.bankDetailConsent && (
                    <Alert variant="danger">{errors.bankDetailConsent}</Alert>
                  )}
                </Form.Group>
                <Button variant="primary" onClick={nextStep}>
                  Next
                </Button>
              </div>
            )}

            {step === 2 && (
              <div>
                <h3>Step 2: Sign and Submit</h3>
                <p>
                  By signing this page, I confirm that I fully understand the
                  content and agree to adhere to it at all times. I also agree
                  that all the details provided in this document are accurate
                  and complete to the best of my knowledge.
                </p>
                <Form.Group className="mb-3">
                  <Form.Label>Signature</Form.Label>
                  <div className="signature-pad">
                    <SignaturePad
                      ref={sigPadRef}
                      penColor="black"
                      canvasProps={{ className: "signature-canvas" }} // Customize the canvas appearance
                    />
                  </div>
                  {errors.signature && (
                    <Alert variant="danger">{errors.signature}</Alert>
                  )}
                  <Button
                    variant="secondary"
                    onClick={clearSignature}
                    className="mt-2"
                  >
                    Clear Signature
                  </Button>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    name="consent"
                    label="Clear By ticking this box I consent to the company processing my
                data and the evidence of this document being stored within their
                system for the purpose of work finding services."
                    checked={formData.consent} // Use checked for checkboxes
                    onChange={handleChange}
                    isInvalid={!!errors.consent}
                  />
                  {errors.consent && (
                    <Alert variant="danger">{errors.consent}</Alert>
                  )}
                </Form.Group>
                <Button variant="secondary" onClick={prevStep} className="me-2">
                  Previous
                </Button>
                <Button variant="success" type="submit">
                  Submit
                </Button>
              </div>
            )}
          </Form>
        </>
      )}
    </Container>
  );
};

const mapStateToProps = (state) => ({
  currentDocument: state.user.currentDocument,
  documentList: state.user.documentList,
  user: state.user.loggedInUserData,
  sasToken: state.user.sasToken,
  ipAddress: state.user.ipAddress,
});
export default connect(mapStateToProps, { getSasToken })(BankDetails);
